/**
 * Single source of truth for mobile app download links, consumed by
 * components/AppDownloadQR.js. Edit URLs HERE ONLY — every screen that renders
 * the QR cards picks the change up automatically.
 *
 * NOTE: two rider package ids exist in the codebase history (com.suku.rider and
 * com.lusuku.rider). com.suku.rider is used below as the current listing — if
 * the live Play listing differs, fix it here.
 */
export const APP_LINKS = [
  {
    key: "rider-android",
    name: "Suku Rider",
    audience: "Riders & delivery agents",
    platform: "Android",
    url: "https://play.google.com/store/apps/details?id=com.suku.rider",
  },
  {
    key: "customer-android",
    name: "Lusuku",
    audience: "Customers",
    platform: "Android",
    url: "https://play.google.com/store/apps/details?id=com.lusuku",
  },
  {
    key: "customer-ios",
    name: "Lusuku",
    audience: "Customers",
    platform: "iOS",
    url: "https://apps.apple.com/ug/app/lusuku/id1622613658",
  },
];

export const getAppLinks = (keys) =>
  !keys || !keys.length ? APP_LINKS : APP_LINKS.filter((a) => keys.includes(a.key));
